module.exports = {"show_business_contact":true}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/en_hk/setting/contact/setting.json
// module id = 594
// module chunks = 0 1 2 3 4 5